import { ArrowLeftOutlined } from "@ant-design/icons";
import { Image } from "antd";
import * as appRoutes from "config/routes.config";
import { FC, useEffect, useState } from "react";
import s from "./assets/tabs.module.css";

//!IMAGES
import closeIcon from "assets/images/app/delete.svg";
import Container from "components/container";
import AppButton from "components/libs/button";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import CustomButton from "screens/teacher/components/CustomButton";
import { setFullscreen } from "store/app/appSlice";
import { setUserConnect } from "store/auth/authSlice";
import Fullscreen from "../../../../assets/images/app/fullscreen.svg";
import Cours from "../../../../assets/images/teacher/cours.svg";
import Exo from "../../../../assets/images/teacher/exo.svg";
import Quiz from "../../../../assets/images/teacher/quiz.svg";

interface TabsStudent {
  idChapter?: string;
  level?: string;
  textBack?: string;
  linkTo?: string;
  isPageStudentQuiz?: boolean;
  onClick?: () => void;
  isFullscreen?: boolean;
  onRequest: () => void;
  onExit: () => void;
}

const TabsStudent: FC<TabsStudent> = ({
  idChapter,
  level,
  textBack,
  isPageStudentQuiz,
  onClick,
  isFullscreen,
  onRequest,
  onExit,
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams<"id">();
  const dispatch = useDispatch();
  const { isLoggedIn } = useSelector((state) => state.auth);
  const [tempIdCours, setTempIdCours] = useState<any>("");
  const [tempIdChapter, setTempIdChapter] = useState<any>("");

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 767);
  };
  window.addEventListener('resize', handleResize);

  useEffect(() => {
    let coursId: any = localStorage.getItem("idCours");
    let chapterId = localStorage.getItem("chapterId");
    setTempIdCours(coursId);
    setTempIdChapter(chapterId);
  }, [tempIdCours, tempIdChapter]);

  return (
    <Container>
      <div className={s.__content__tabs} onClick={onClick}>
        {!isMobile && <div className={!isFullscreen ? s.header : s.fullHeader}>
          {isFullscreen && <Link
            to={
              isPageStudentQuiz
                ? "#"
                : `${appRoutes.STUDENT_CHAPTERS}/${tempIdCours}`
            }
          >
            <div className={s.__back}>
              {textBack && (
                <span>
                  <ArrowLeftOutlined
                    style={{
                      position: "relative",
                      top: "2px",
                    }}
                  />{" "}
                  {textBack}
                </span>
              )}
            </div>
          </Link>}

          {!isFullscreen && location.pathname === `${appRoutes.STUDENT_FIND_COURSE}/${params.id!}` ?
            <AppButton
              onClick={() => {
                onRequest();
                dispatch(setFullscreen(true));
              }}
              className={s.fullscreenButton}
            >
              <Image preview={false} src={Fullscreen} width={15} />
              <span> Mode plein écran</span>
            </AppButton> : <div style={{ width: "34%" }}></div>
          }

          <div className={s.tabButtons}>
            <Link to={`${appRoutes.STUDENT_FIND_COURSE}/${tempIdChapter}`}>
              <div
                className={s.tabs}
                style={{
                  background: `${location.pathname === `/student/courses/${params.id!}` &&
                    "var(--first-color)"
                    }`,
                }}
              >
                <Image
                  preview={false}
                  width={65}
                  src={Cours}
                  alt="teacher avatar"
                />
              </div>
            </Link>
            <Link
              to={`${isLoggedIn
                ? `${appRoutes.STUDENT_SEARCH_QUIZZ}/${params.id}`
                : "#"
                } `}
            >
              <div
                onClick={() => {
                  if (!isLoggedIn) {
                    dispatch(setUserConnect(true));
                  }
                }}
                className={s.tabs}
                style={{
                  background: `${(location.pathname ===
                    `/student/quizz/levels/${params.id!}` &&
                    "var(--first-color)") ||
                    (location.pathname ===
                      `/student/search/quizz/${params.id!}` &&
                      "var(--first-color)") ||
                    (location.pathname === `/student/quizz/${params.id!}` &&
                      "var(--first-color)")
                    }`,
                }}
              >
                <Image
                  preview={false}
                  width={65}
                  src={Quiz}
                  alt="teacher avatar"
                />
              </div>
            </Link>
            <Link to={`${appRoutes.STUDENT_EXOS}/${tempIdChapter}`}>
              <div
                className={s.tabs}
                style={{
                  background: `${(location.pathname === `/student/exercices/${params.id!}` &&
                    "var(--first-color)") ||
                    (location.pathname === `/student/exercice/${params.id!}` &&
                      "var(--first-color)")
                    }`,
                }}
              >
                <Image
                  preview={false}
                  width={30}
                  src={Exo}
                  alt="teacher avatar"
                />
              </div>
            </Link>
          </div>
        </div>}

        {!isFullscreen && !isMobile && <Link
          to={
            /* isPageStudentQuiz
              ? "#"
              : `${appRoutes.STUDENT_CHAPTERS}/${tempIdCours}` */
            `${appRoutes.STUDENT_CHAPTERS}/${tempIdCours}`
          }
        >
          <div className={s.__back}>
            {textBack && (
              <span>
                <ArrowLeftOutlined
                  className={s.icon}
                  style={{
                    position: "relative",
                    top: "2px",
                  }}
                />{" "}
                {textBack}
              </span>
            )}
          </div>
        </Link>}

        {isMobile && <div className={isFullscreen ? s.mobileMenuFullscreen : s.mobileMenu}>
          <div style={{ width: "50%" }}>
            {!isFullscreen && location.pathname === `${appRoutes.STUDENT_FIND_COURSE}/${params.id!}` &&
              <CustomButton
                onClick={() => {
                  onRequest();
                  dispatch(setFullscreen(true));
                }}
                className=""
                icon={Fullscreen}
                iconSize={12}
                children={" Mode plein écran"}
                style={{ fontSize: "10px", padding: "0.5em", marginBottom: "7px" }}
              />}
            {isFullscreen &&
              <CustomButton
                onClick={() => {
                  onExit();
                  dispatch(setFullscreen(false));
                }}
                className=""
                icon={closeIcon}
                iconSize={12}
                children={" Fermer"}
                style={{ fontSize: "10px", padding: "0.5em", marginBottom: "7px" }}
              />}
            <Link
              to={
                `${appRoutes.STUDENT_FIND_COURSE}/${tempIdCours}`
              }
            >
              <div style={{ fontSize: "12px", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-start", fontFamily: "CartoonFont", color: "#333", fontWeight: "500", width: "100%" }}>
                {textBack && (
                  <span>
                    <ArrowLeftOutlined />{" "}
                    {textBack}
                  </span>
                )}
              </div>
            </Link>
          </div>
          <div style={{ width: isMobile ? "auto" : "50%", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-end" }}>
            <Link to={`${appRoutes.STUDENT_FIND_COURSE}/${tempIdChapter}`}>
              <div
                className={s.mobileTabs}
                style={{
                  background: `${location.pathname ===
                    `${appRoutes.STUDENT_FIND_COURSE}/${params.id!}` &&
                    "var(--first-color)"
                    }`,
                }}
              >
                <Image
                  preview={false}
                  width={35}
                  src={Cours}
                  alt="teacher avatar"
                />
              </div>
            </Link>
            <Link to={`${isLoggedIn
              ? `${appRoutes.STUDENT_SEARCH_QUIZZ}/${params.id}`
              : "#"
              } `}>
              <div
                className={s.mobileTabs}
                style={{
                  background: `${(location.pathname ===
                    `/student/quizz/levels/${params.id!}` &&
                    "var(--first-color)") ||
                    (location.pathname ===
                      `/student/search/quizz/${params.id!}` &&
                      "var(--first-color)") ||
                    (location.pathname === `/student/quizz/${params.id!}` &&
                      "var(--first-color)")
                    }`,
                }}
              >
                <Image
                  preview={false}
                  width={35}
                  src={Quiz}
                  alt="teacher avatar"
                />
              </div>
            </Link>
            <Link to={`${appRoutes.STUDENT_EXOS}/${tempIdChapter}`}>
              <div
                className={s.mobileTabs}
                style={{
                  background: `${(location.pathname === `/student/exercices/${params.id!}` &&
                    "var(--first-color)") ||
                    (location.pathname === `/student/exercice/${params.id!}` &&
                      "var(--first-color)")
                    }`,
                }}
              >
                <Image
                  preview={false}
                  width={15}
                  src={Exo}
                  alt="teacher avatar"
                />
              </div>
            </Link>
          </div>
        </div>}
      </div>
    </Container>
  );
};

export default TabsStudent;
